import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=98e64d38&scoped=true"
import script from "./PublicLayout.vue?vue&type=script&lang=js"
export * from "./PublicLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e64d38",
  null
  
)

export default component.exports